import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './SophisticatedTooltipLink.scss';
const SophisticatedTooltipLink = (_param)=>{
    var { className , children  } = _param, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        className: c(s['root'], className)
    }, rest), children);
};
SophisticatedTooltipLink.displayName = 'SophisticatedTooltipLink';
export default SophisticatedTooltipLink;
